import React from 'react';
import { FormGroup, HelpBlock } from 'react-bootstrap';
import { getOrgTermsContent } from '../content/utils.js';

export const FormError = ({ submitError }) => {
  return (
    <FormGroup validationState="error">
      <HelpBlock
        style={{
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          maxWidth: '100%',
          overflowWrap: 'break-word',
        }}
      >
        {getOrgTermsContent(submitError)}
      </HelpBlock>
    </FormGroup>
  );
};
